<template>
  <div>
    <!-- welcome message and the scrolling reviews section -->
    <welcome-header :reviews="reviews" @openModal="modalOpen"></welcome-header>

    <!-- homesby360 services . RENTALS - MANAGE - BUYER - SELL -->
    <services :userAuth="userAuth"></services>

    <!-- stats from homemanager management houses (count) - all the sold homes (count) - and all the houses that the client can buy (count) -->
    <stats :count="homes"></stats>

    <scrolling @count="updateCount" @openModal="modalOpen"></scrolling>

    <news></news>
    <team></team>

    <section
      v-show="reviews.length > 0"
      class="sm:hidden block w-full mx-auto text-center text-gray-600 body-font"
    >
      <div class="px-2 pb-4 mx-auto">
        <div class="text-center text-gray-900">
          <h2 class="text-3xl font-extrabold tracking-tight sm:text-4xl">
            Testimonials
          </h2>
          <div>
            <button
              @click="redirectReviews()"
              type="button"
              class="inline-flex uppercase items-center px-3 py-1 border-solid border-2 border-indigo-900 text-base font-medium rounded-md shadow-xl text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none"
            >
              View More
            </button>
          </div>
        </div>
        <div class="flex flex-wrap">
          <div
            v-for="(review, i) in filterReviews.slice(0, 4)"
            :key="i"
            class="p-2 md:w-1/2 w-full"
          >
            <div class="h-full bg-gray-100 p-8 rounded">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                class="block w-5 h-5 text-gray-400 mb-4"
                viewBox="0 0 975.036 975.036"
              >
                <path
                  d="M925.036 57.197h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.399 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l36 76c11.6 24.399 40.3 35.1 65.1 24.399 66.2-28.6 122.101-64.8 167.7-108.8 55.601-53.7 93.7-114.3 114.3-181.9 20.601-67.6 30.9-159.8 30.9-276.8v-239c0-27.599-22.401-50-50-50zM106.036 913.497c65.4-28.5 121-64.699 166.9-108.6 56.1-53.7 94.4-114.1 115-181.2 20.6-67.1 30.899-159.6 30.899-277.5v-239c0-27.6-22.399-50-50-50h-304c-27.6 0-50 22.4-50 50v304c0 27.601 22.4 50 50 50h145.5c-1.9 79.601-20.4 143.3-55.4 191.2-27.6 37.8-69.4 69.1-125.3 93.8-25.7 11.3-36.8 41.7-24.8 67.101l35.9 75.8c11.601 24.399 40.501 35.2 65.301 24.399z"
                ></path>
              </svg>
              <div class="descinline leading-relaxed mb-6">
                {{ review.review | shortText(400) }}
                <a
                  class="linkCustom"
                  v-if="review.review.length >= 300"
                  @click="toggler(review)"
                  ><span class="text-white -ml-2">...</span> Continue reading
                </a>
              </div>
              <a class="inline-flex items-center">
                <img
                  alt="testimonial"
                  class="rounded-full opacity-50"
                  :src="url + review.name + rest"
                />
                <span class="flex-grow flex flex-col pl-2">
                  <span class="title-font -ml-7 font-medium text-gray-900">{{
                    review.name
                  }}</span>
                  <span class="-mt-2 -ml-1 text-gray-500 text-sm"
                    >Homesby360 Client</span
                  >
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Modal CALL TO ACTION -->
    <div v-if="displayModal">
      <contact-modal @closeModal="modalClose"></contact-modal>
    </div>

    <footer
      class="text-center text-white bg-gradient-to-r from-gray-800 via-gray-900 to-black"
    >
      <div
        class="text-center p-4"
        style="background-color: rgba(0, 0, 0, 0.2);"
      >
        © 2022 Copyright:
        <a class="text-white" href="https://www.vqventure.com/"
          >Vision Quest Venture</a
        >
      </div>
    </footer>

    <v-dialog
      v-model="openDialog"
      transition="dialog-top-transition"
      max-width="600"
    >
      <template>
        <v-card>
          <v-toolbar color="primary" dark>Opening from the top</v-toolbar>
          <v-card-text>
            <div class="text-h2 pa-12">Hello world!</div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="openDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <div class="block sm:hidden my-16"></div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import welcomeHeader from "./WelcomeHeader.vue";
import stats from "./Stats.vue";
import contactModal from "./ContactModal.vue";
import services from "./Services.vue";
import news from "./PublicNews.vue";
import team from "./Team.vue";
export default {
  components: { team, news, stats, welcomeHeader, services, contactModal },

  data: () => ({
    reviews: [],
    displayModal: false,
    stats: "",
    homes: 0,
    openDialog: false,
    url: "https://ui-avatars.com/api/?name=",
    rest: "&background=a1a1a1&color=fff"
  }),

  created() {
    this.getReviews();
    this.getStats();
  },

  filters: {
    shortText(value, limit) {
      if (value) {
        return value.substring(0, limit);
      }
    }
  },

  computed: {
    ...mapGetters({
      userAuth: "userAuth"
    }),

    filterReviews() {
      return this.reviews.filter(val => {
        return val.review !== null;
      });
    }
  },

  methods: {
    redirectReviews() {
      this.$router.push({ name: "Reviews" });
    },

    getReviews() {
      window.axios.get("/api/reviews").then(res => {
        this.reviews = res.data;
      });
    },

    getStats() {
      window.axios.get("/api/getStats").then(res => {
        this.stats = res.data;
      });
    },

    modalClose() {
      this.displayModal = false;
    },

    updateCount(value) {
      this.homes = value;
    },

    modalOpen() {
      if (this.userAuth) {
        this.redirectListing();
      } else if (!sessionStorage.getItem("modal")) {
        this.displayModal = true;
      } else {
        this.redirectListing();
      }
    },

    redirectListing() {
      this.displayModal = false;
      this.$router.push({ name: "listings" });
    }
  }
};
</script>

<style lang="scss">
.ml2 {
  font-weight: 900;
  font-size: 3.5em;
}

.ml2 .letter {
  display: inline-block;
  line-height: 1em;
}

$color-white: #fff;
$color-antiwhite: #edf2f4;
$color-coolgray: #8d99ae;
$color-gunmetal: #000000;
$color-imperialred: #8d99ae;
$color-candyred: #d90429;
$color-bordered: #2b2d42;

// video {
//   overflow: hidden;
//   position: absolute;
//   top: 0;
//   left: 0;
//   min-width: 100%;
//   max-height: 100vh;
//   object-fit: cover;
//   opacity: 0.2;
//   pointer-events: none;
// }

#contactHidden {
  display: none;
}

.hiddenCard {
  display: block;
  position: absolute;
  top: -50;
  right: 150px;
}

#hiddenCard {
  display: none;
}

.menuFloating {
  z-index: 100;
  position: fixed;
  left: 0px;
  top: 200px;
}

.hiddeIcon {
  display: block;
}

.mobileMargin {
  display: block;
  margin-left: 7%;
}

@media (min-width: 320px) and (max-width: 1200px) {
  .mobileMargin {
    display: block;
    margin: auto;
    margin-top: 12%;
  }

  .hiddeIcon {
    display: none;
  }
  .hiddenCard {
    display: none;
  }

  #hiddenCard {
    display: block;
  }
  #contactHidden {
    display: block;
  }
}

@media (min-width: 375px) and (max-width: 800px) {
  .sticky-container {
    display: none;
  }

  .menuFloating {
    display: none;
  }

  video {
    display: none;
  }

  #contactHidden {
    display: block;
  }

  .menuFloating {
    position: fixed;
    left: 0;
    top: 0;
  }
}

.plan-ribbon {
  font-size: 15px;
  text-transform: uppercase;
  color: #fff;
  background-color: #21ba45;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 55px;
  min-width: 200px;
  text-align: center;
  position: absolute;
  top: 0px;
  right: -45px;
  -webkit-transform: rotate(40deg);
  -moz-transform: rotate(40deg);
  -ms-transform: rotate(40deg);
  -o-transform: rotate(40deg);
  transform: rotate(45deg);
  -webkit-box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.2);
  z-index: 1;
  line-height: 10px;
}

.sticky-container {
  /*background-color: #333;*/
  z-index: 1000;
  padding: 0px;
  margin: 0px;
  position: fixed;
  right: -95px;
  top: 130px;
  width: 162px;
}
.sticky li {
  list-style-type: none;
  background-color: #333;
  color: #efefef;
  height: 43px;
  padding: 0px;
  margin: 0px 0px 1px 0px;
  -webkit-transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
  transition: all 0.25s ease-in-out;
  cursor: pointer;
  filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale");
  filter: gray;
  -webkit-filter: grayscale(100%);
}
.sticky li:hover {
  margin-left: -115px;
  /*-webkit-transform: translateX(-115px);
      -moz-transform: translateX(-115px);
      -o-transform: translateX(-115px);
      -ms-transform: translateX(-115px);
      transform:translateX(-115px);*/
  /*background-color: #8e44ad;*/
  filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='1 0 0 0 0, 0 1 0 0 0, 0 0 1 0 0, 0 0 0 1 0'/></filter></svg>#grayscale");
  -webkit-filter: grayscale(0%);
}
.sticky li img {
  float: left;
  margin: 5px 5px;
  margin-right: 10px;
}
.sticky li p {
  padding: 0px;
  margin: 0px;
  text-transform: uppercase;
  line-height: 43px;
}

.sticky li p a {
  color: #ecf0f1;
}
</style>
